/* DIYION: consented UX analytics. No customer identity or personalisation data is sent as custom data. */
(() => {
  'use strict';
  if (window.DiyionClarity || window.Shopify?.designMode) return;
  const source = document.currentScript;
  const project = source?.dataset.project;
  const pageType = source?.dataset.pageType || 'other';
  if (!/^[a-z0-9]+$/.test(project || '') || /customer|account|checkout|password/.test(pageType)) return;
  let installed = false, active = false, stopped = false, initialView = false;
  const stopTimers = [];
  const consent = () => {
    const api = window.Shopify?.customerPrivacy;
    const explicit = api?.currentVisitorConsent?.();
    return {
      analytics: explicit?.analytics === 'yes' && api.analyticsProcessingAllowed(),
      ads: explicit?.marketing === 'yes' && api.marketingAllowed() && api.saleOfDataAllowed()
    };
  };
  const command = (...args) => { if (typeof window.clarity === 'function') window.clarity(...args); };
  function event(name) { if (active && consent().analytics) command('event', name); }
  function tagPage() {
    command('set', 'store_language', document.documentElement.lang.slice(0, 2));
    command('set', 'page_type', pageType);
    if (!initialView) {
      initialView = true;
      if (pageType === 'product') event('product_view');
      if (pageType === 'cart') event('cart_view');
    }
  }
  function sync() {
    const state = consent();
    const signal = { analytics_Storage: state.analytics ? 'granted' : 'denied', ad_Storage: state.ads && state.analytics ? 'granted' : 'denied' };
    if (state.analytics) {
      stopTimers.splice(0).forEach(clearTimeout);
      active = true;
      if (!installed) {
        installed = true;
        window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
        command('consentv2', signal);
        const script = document.createElement('script');
        script.async = true; script.src = 'https://www.clarity.ms/tag/' + project;
        script.dataset.diyionClarity = project;
        script.addEventListener('error', () => { active = false; });
        script.addEventListener('load', () => { if (!consent().analytics) stopRecording(); });
        document.head.appendChild(script);
      } else {
        if (stopped) { command('start'); stopped = false; }
        command('consentv2', signal);
      }
      tagPage();
    } else if (installed) {
      active = false;
      command('consentv2', signal);
      stopRecording();
    }
  }
  function stopRecording() {
    active = false; stopped = true;
    if (window.clarity?.v) command('stop');
    // ConsentV2 restarts its library in cookieless mode after 250 ms. Stop that mode as well.
    stopTimers.splice(0).forEach(clearTimeout);
    for (const delay of [350, 1000, 3000]) stopTimers.push(setTimeout(() => {
      if (!consent().analytics && window.clarity?.v) command('stop');
    }, delay));
  }
  // Also stop a delayed library that finishes loading after consent was withdrawn.
  document.addEventListener('load', e => {
    if (installed && !consent().analytics && e.target instanceof HTMLScriptElement && /^https:\/\/(?:www|scripts)\.clarity\.ms\//.test(e.target.src)) stopRecording();
  }, true);
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('diyion:cart-added', () => event('add_to_cart'));
  document.addEventListener('submit', e => {
    if (e.target.id === 'CommerceCartForm' && e.submitter?.name === 'checkout' && !e.defaultPrevented) event('checkout_start');
  });
  addEventListener('pageshow', sync);
  window.DiyionClarity = Object.freeze({ project, status: () => ({ installed, active, consent: consent() }) });
  if (window.Shopify?.customerPrivacy) sync();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });
})();
